import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component, ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList, ViewChild,
  ViewChildren
} from '@angular/core';
import { ActiveDescendantKeyManager } from '@angular/cdk/a11y';
import get from 'lodash.get';
import { HistoryTerm, Suggestion } from '~app/modules/generic/models';
import { Product } from '~shared/models';
import { SUGGESTIONS_LIST_ANIMATIONS } from './animations/suggestions-list.animations';
import {
  SuggestionItemComponent
} from '~app/modules/generic/components/header/suggestion-item/suggestion-item.component';
import { SelectSuggestionByKeyboardService } from '~app/modules/generic/services/select-suggestion-by-keyboard.service';
import { ITEMS_TO_SHOW, PRODUCTS_TO_SHOW } from '~app/modules/generic/constants';
import { APP_SEARCH_ROUTE } from '~shared/constants';
import { KeyboardUtil } from '~shared/utils/keyboard-util';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { environment } from '~env/environment';

@Component({
  selector: 'app-desktop-suggestions-list',
  templateUrl: './desktop-suggestions-list.component.html',
  styleUrls: ['./desktop-suggestions-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: SUGGESTIONS_LIST_ANIMATIONS
})
export class DesktopSuggestionsListComponent implements AfterViewInit {
  @ViewChild('searchByPhotoInput') searchByPhotoInput: ElementRef;
  @Input() suggestions: Suggestion[] = [];
  @Input() suggestionsProducts: Product[] = [];
  @Input() historyTerms: HistoryTerm[] = [];
  @Input() isSuggestionsListVisible: boolean;
  @Input() searchQuery: string;

  @Output() promoClick = new EventEmitter<boolean>();
  @Output() termSelected = new EventEmitter<Suggestion | HistoryTerm>();
  @Output() historyRemoved = new EventEmitter<HistoryTerm>();
  @Output() productSelected = new EventEmitter<{ product: Product, priceType: PriceTypes}>();

  @ViewChildren(SuggestionItemComponent) items: QueryList<SuggestionItemComponent>;

  MAX_FILE_SIZE = 15 * 1024 * 1024; // 15 MB

  itemsToShow = ITEMS_TO_SHOW;
  productsToShow = PRODUCTS_TO_SHOW;
  searchRoute = `/${APP_SEARCH_ROUTE}`;

  private keyManager: ActiveDescendantKeyManager<SuggestionItemComponent>;

  constructor(private selectSuggestionByKeyboardService: SelectSuggestionByKeyboardService) {

  }

  ngAfterViewInit() {
    this.keyManager = new ActiveDescendantKeyManager(this.items).withWrap();
    this.listenToDesktopInputKeys();
  }

  onSearchByPhotoSuggestionClicked(event):void {
    event.stopPropagation();
    event.preventDefault();
    this.searchByPhotoInput.nativeElement.click();
  }

  handleFileChange(file) {
    if (file && !(file.size > this.MAX_FILE_SIZE)) {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const timeStamp = Date.now();
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = 300;
          canvas.height = 300;
          ctx.drawImage(img, 0, 0, 300, 300);

          const resizedBase64 = canvas.toDataURL('image/jpeg', 0.8);
          clearSessionStorageByPrefix('photoSearched');
          sessionStorage.setItem(`photoSearched-${timeStamp}`, resizedBase64);
          window.location.href = `${environment.appBaseUrl()}/${APP_SEARCH_ROUTE}?searchByPhoto=${timeStamp}`;

          console.log('xx', `${environment.appBaseUrl()}/${APP_SEARCH_ROUTE}?searchByPhoto=${timeStamp}`)
        };
        img.src = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }
  handlePhotoSearch(event) {
    const file = event.target.files?.[0];
    this.handleFileChange(file);
  }

  private listenToDesktopInputKeys() {
    this.selectSuggestionByKeyboardService.keyDownObservable.subscribe(event => {
      if (KeyboardUtil.isEnter(event) && this.keyManager.activeItem) {
        const suggestion = get(this.keyManager.activeItem, 'suggestion');
        const product = get(this.keyManager.activeItem, 'product');

        if (this.keyManager.activeItem instanceof SuggestionItemComponent) {
          this.termSelected.emit(suggestion);
        } else {
          this.productSelected.emit(product);
        }
        this.keyManager.setActiveItem(null);
      } else if (KeyboardUtil.isArrowUp(event) || KeyboardUtil.isArrowDown(event)) {
        this.keyManager.onKeydown(event);
        this.selectSuggestionByKeyboardService.setSsgSelected();
      }
    });
  }
}

const clearSessionStorageByPrefix = (prefix) => {
  for (let i = sessionStorage.length - 1; i >= 0; i--) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith(prefix)) {
      sessionStorage.removeItem(key);
    }
  }
};
